{
  "home-page-title": "Webapp",
  "clear-btn": "清除",
  "close-btn": "关闭",
  "cancel-btn": "取消",
  "delete-btn": "删除",
  "share-btn": "分享",
  "download-btn": "下载",
  "ok-btn": "确认",
  "done-btn": "完成",
  "yes-btn": "是",
  "no-btn": "否",
  "create-story-btn": "建立故事",
  "submit-registration-btn": "开启相册",
  "save-btn": "储存",
  "apply-btn": "套用",
  "checkout-btn": "结账",
  "info-title": "资讯",
  "registration-page-title": "注册",
  "contact-completion-page-title": "完成联络资料",
  "registration-name-placeholder": "您的姓名",
  "registration-email-placeholder": "您的电子邮件",
  "registration-email-or-phone-placeholder": "您的电子邮件或美国电话号码",
  "registration-country-code-default": "美国 +1",
  "registration-accept-label": "我同意",
  "registration-privacy-link": "条款与细则",
  "registration-sms-agreement-label": "我同意接收来自 Storibox 的通知讯息至上方提供的电话号码。我明白我将收到包含更新与图片链接的 SMS 讯息。可能会产生数据及讯息费用。如要取消，请回覆 STOP。",
  "registration-submit-loading-label": "载入中...",
  "registration-create-attendee-error-message": "建立使用者失败。请稍后再试。",
  "registration-create-attendee-email-confirmation-error-message": "建立使用者失败。请稍后再试。请确认您的电子邮件已完成验证。",
  "registration-invalid-us-phone-message": "请仅使用美国电话号码，例如：+11234567890。",
  "registration-us-phone-length-message": "电话号码在国码（+1）后应为 10 位数，但您输入的是 {{length}} 位。",
  "registration-contact-required-message": "电子邮件或电话号码为必填。",
  "registration-invalid-email-message": "请输入有效的电子邮件地址。",
  "registration-email-required-message": "电子邮件为必填。",
  "registration-sms-consent-required-message": "您必须同意 SMS 条款，否则无法注册此服务。",
  "registration-privacy-consent-required-message": "您必须同意条款与细则，否则无法注册此服务。",
  "incognito-page-title": "侦测到无痕模式",
  "incognito-main-title": "您目前在私人模式",
  "incognito-message": "请复制此链接并于一般浏览器视窗中开启。",
  "incognito-link-placeholder": "您的链接",
  "incognito-copy-link-btn": "复制链接",
  "incognito-copy-link-title": "将链接复制到剪贴板",
  "incognito-copy-success-message": "✓ 已复制链接到剪贴板！",
  "incognito-copy-manual-message": "请手动复制上方链接",
  "incognito-safari-step-one-text": "点选「分页」按钮",
  "incognito-safari-step-two-html": "点选 <strong>[number]</strong> 个分页，然后点选「完成」。",
  "incognito-chrome-step-one-text": "点选「分页」按钮。",
  "incognito-chrome-step-two-html": "点选 <strong>[number]</strong> 个分页。",
  "selfies-empty-title": "尚未有自拍！",
  "selfies-empty-message": "请为同行的每位成员\n新增清晰的人像照片，\n以便快速找到\n您的影像。",
  "selfies-add-btn": "+ 新增",
  "purchase-btn": "购买",
  "home-select-all-btn": "全选",
  "home-selected-count-label_one": "已选择 1 项",
  "home-selected-count-label_other": "已选择 {{count}} 项",
  "home-empty-album-message": "相册是空的",
  "home-empty-album-subtext-message": "您的相册中<br>目前没有任何图片。",
  "home-qr-modal-title": "我的相册代码",
  "home-qr-modal-message": "请在自助机扫描此 QR 以访问您的照片，或在流动摄影师要求时出示。",
  "home-qr-scanner-message": "扫描照片自助机中您照片或视频上的 QR code，将媒体与此应用程序链接。",
  "home-qr-camera-access-message": "🎥 请确认您已开启相机权限以扫描 QR code。",
  "home-qr-scanner-show-my-qr-btn": "显示我的 QR",
  "menu-registered-selfies": "已注册的人脸",
  "menu-qr-scanner": "QR 扫描器",
  "menu-album-code": "我的相册代码",
  "menu-privacy": "条款与细则",
  "menu-faq": "常见问题",
  "menu-support": "支持",
  "home-step-label": "步骤 {{amount}} / {{total}}",
  "home-select-up-to-images-title_one": "最多选择 1 张图片",
  "home-select-up-to-images-title_other": "最多选择 {{count}} 张图片",
  "home-select-as-many-images-title": "可选择任意数量的图片",
  "home-select-target-label": "用于「{{name}}」",
  "home-no-albums-found-message": "找不到任何相册。",
  "home-event-config-missing-message": "此活动尚未设定 Web 应用。",
  "home-create-story-waiting-message": "正在建立您的故事。请几分钟后再查看相册。",
  "home-ugc-tooltip-message": "您可以从相册上传照片，并在自助机列印！",
  "home-face-reco-tooltip-message": "请上传您的自拍，或同行每位成员清晰的人像照片，以便我们找到您的影像！",
  "home-select-to-share-or-download-message": "请至少选择一张图片以分享或下载。",
  "home-select-without-watermark-message": "只有无浮水印的图片可分享或下载。",
  "home-select-to-delete-message": "请至少选择一张图片以删除。",
  "home-share-download-locked-message": "您选择的部分照片已被锁定。若要分享或下载，请购买 Digital Pass。",
  "home-face-register-help-message": "请确保脸部光线均匀且完整可见，并保持自然表情。",
  "home-no-selfies-suggestion-message": "看起来您尚未注册自拍。立即拍摄自拍以获取珍贵回忆。",
  "home-no-face-mask-message": "请勿佩戴口罩",
  "home-selfie-maybe-later-btn": "稍后",
  "home-delete-stock-warning-message": "您选择了活动素材图片要删除。此图片无法从您的相册删除，将被跳过。",
  "home-delete-confirm-message": "从相册删除图片后无法复原。确定要继续吗？",
  "home-delete-reason-not-wanted": "我不想要这些图片在相册中",
  "home-delete-reason-not-mine": "这些不是我的图片",
  "home-delete-confirm-btn": "是，删除",
  "home-upload-unsupported-format-message": "不支持的图片格式。请使用其他图片文件。",
  "home-upload-generic-error-message": "上传照片时发生错误。请重试或联络支持。",
  "home-upload-limit-reached-message": "您已达照片上传上限。如需上传更多照片，请联络支持。",
  "home-upload-processing-error-message": "处理照片时发生错误。请重试或联络支持。",
  "home-upload-processing-message": "您的照片将于一分钟内出现在相册中！",
  "home-upload-photo-message": "从相册上传照片以供列印！",
  "home-turn-me-into-tag-upload-message": "拍摄自拍，或从相册上传人像照片。",
  "home-turn-me-into-tag-processing-message": "我们正在转换您的图片！请约一分钟后刷新此页面。",
  "home-download-waiting-message": "正在下载文件。<br/>请稍候。",
  "download-selection-too-large-message": "抱歉，此选取内容太大，无法一次下载。请选择较少照片，或逐张下载。",
  "home-download-360-message": "这是互动内容，建议在相册内查看。您仍可下载原始文件以在线上分享，或日后在支持 360 球形格式的应用程序中查看。",
  "home-scanned-image-confirm-message": "很棒的照片！为了安全请确认：这是您的图片吗？",
  "home-media-share-title": "媒体",
  "webapp-share-title": "来看看我的 Storibox 相册！",
  "webapp-ogp-title": "我的 Storibox 相册",
  "webapp-ogp-description": "查看并分享我在 Storibox 相册中的照片与视频。",
  "home-share-files-unsupported-message": "您的浏览器不支持文件分享。请使用其他浏览器，或直接下载文件。",
  "home-share-files-waiting-message": "正在下载要分享的文件。<br/>请稍候。",
  "title-select-a-combo": "选择组合",
  "title-select-a-la-carte": "单点项目",
  "title-shopping-cart": "购物车",
  "checkout-change-image-btn": "更换图片",
  "checkout-empty-cart-message": "购物车是空的",
  "checkout-add-product-btn": "新增商品",
  "checkout-subtotal-label": "小计:",
  "checkout-taxes-label": "税金 (0%)",
  "checkout-total-label": "总金额:",
  "checkout-promo-code-placeholder": "优惠代码",
  "checkout-add-on-btn": "+ 加购",
  "checkout-invalid-promo-code-message": "无效或不适用的优惠代码！",
  "checkout-discount-label": "折扣: {{title}}",
  "checkout-delete-restriction-message": "如要购买加购项目，购物车中必须至少保留一个套装。若需更换套装，请先移除购物车中的所有加购项目。",
  "checkout-digital-package-upsell-message": "要将<br>数位套装加入<br>购物车，并取得<br>所有数位内容的访问权限吗？",
  "photo-plus-maybe-later-btn": "稍后",
  "photo-plus-upgrade-btn": "是，立即升级",
  "checkout-digital-package-duplicate-message": "您的购物车中已包含数位访问套装。<br>在移除或购买目前套装之前，无法新增新套装。",
  "title-change-image": "选择照片",
  "title-select-images": "选择照片",
  "title-registered-selfies": "已注册的人脸",
  "title-privacy": "条款与细则",
  "title-faq": "常见问题",
  "title-shoot": "拍摄",
  "title-remote-shoot": "远端拍摄",
  "title-thank-you": "谢谢",
  "shoot-again-btn": "再拍一次",
  "select-image-done-btn-name_final": "完成",
  "select-image-done-btn-name_incomplete": "下一步",
  "select-image-done-btn-counter_finite": "({{amount}}/{{total}})",
  "select-image-done-btn-counter_infinite": "({{amount}})",
  "remote-shoot-btn": "拍摄",
  "remote-shoot-start-message": "请看著镜头，准備好后按「拍摄」",
  "remote-shoot-countdown-message": "请看著灯号",
  "remote-shoot-rendering-message": "正在建立您的内容。几秒后请查看相册，欣赏全新精彩视频！"
}
